import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const DIALOG_WIDTH = 360;
export const DIALOG_HEADER_PADDING = gridSize * 2;
export const DIALOG_INNER_WIDTH = DIALOG_WIDTH - DIALOG_HEADER_PADDING;
export const COMPONENT_SHORTCUT_OPTION_TYPE = 'component' as const;
